const KEY_API = '74c5e15336c71e6f10e46fc816460a0f';
const IMAGE_URL = 'https://image.tmdb.org/t/p/w500';

export { KEY_API, IMAGE_URL };
